const encodeUtf8Base64 = (value: string) => {
  const bytes = new TextEncoder().encode(value)
  const chunkSize = 0x8000
  let binary = ''

  for (let offset = 0; offset < bytes.length; offset += chunkSize) {
    let chunk = ''
    const end = Math.min(offset + chunkSize, bytes.length)

    for (let index = offset; index < end; index += 1) {
      chunk += String.fromCharCode(bytes[index])
    }

    binary += chunk
  }

  return window.btoa(binary)
}

export const encodeBase64HtmlPayloadField = <T extends string | null | undefined>(value: T): T => {
  if (value === null || value === undefined || value === '') {
    return value
  }

  return encodeUtf8Base64(value) as T
}
